import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input, OnDestroy, OnInit
} from '@angular/core';

import { Subscription } from 'rxjs';

import { SdRecipeListComponent } from '@seb/web-design-system/recipe-list';
import { BrandsEnum, DeviceService } from '@seb/web-design-system/core';
import { IRecipeCard } from '@seb/web-design-system/recipe-card';

import { TrackingService } from '../../../services';

@Component({
  selector: 'wc-base-list-recipe',
  templateUrl: './base-recipe-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SdRecipeListComponent]
})
export class BaseRecipeListComponent implements OnInit, OnDestroy {
  @Input()
  recipeCards: IRecipeCard[];

  @Input()
  totalCount: number;

  @Input() class = '';

  @Input()
  isFirst = false;

  @Input()
  isLoading = false;

  @Input()
  brandCorner = BrandsEnum.default;

  private subscriptions = new Subscription();
  public isMobile$: boolean;

  @HostBinding('class')
  get hostClasses(): string {
    return [this.class, 'wc-component is-base'].filter(Boolean).join(' ');
  }

  constructor(
    private deviceService: DeviceService,
    private trackingService: TrackingService,
    private cdRef: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.deviceService.isMobile.subscribe((x) => {
        this.isMobile$ = x;
        this.cdRef.markForCheck();
      })
    );
  }

  recipeClicked(event: IRecipeCard): void {
    this.trackingService.sendEvent('clickseeRecipe', {
      recipeName: event.title,
      author: TrackingService.getRecipeAuthor(event)
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
